import { render, staticRenderFns } from "./NewsBoardContentCreate.vue?vue&type=template&id=788ab586&"
import script from "./NewsBoardContentCreate.vue?vue&type=script&lang=ts&"
export * from "./NewsBoardContentCreate.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoardContentCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports